import {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles = memo((props: IProps) => {
    const {offer, propertyListObj, filterValues, gtmMeta} = props;

    const {pageCount, onPageChange, page, filterRequestState, properties} = propertyListObj;

    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, filterValues);

        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList requestState={filterRequestState} properties={properties} offer={offer} css={propertyListWrapper} gtmMeta={gtmMeta} />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
import {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles = memo((props: IProps) => {
    const {offer, propertyListObj, filterValues, gtmMeta} = props;

    const {pageCount, onPageChange, page, filterRequestState, properties} = propertyListObj;

    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, filterValues);

        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList requestState={filterRequestState} properties={properties} offer={offer} css={propertyListWrapper} gtmMeta={gtmMeta} />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
